import $ from "jquery";

export * from './header/header-uqam';
export * from './liensPlus/liensPlus';
export * from './menuMain/menuMain';
export * from './menuMobile/menuMobile';
export * from './recherche/recherche';
export * from './breadcrumb/breadcrumb';
export * from './footer/footer-uqam';
export * from './accordions/accordions';
export * from './bigFooter/bigFooter';
export * from './langue/langue';
export * from './titre/titre';
export * from './voeux/voeux';
